<template>
  <div id="blog">
    <vue-headful
          :title="$t('pages.blog') + ' - Fernando Mata'"
      />
    <ContentLoader v-if="!hasCalled" />
    <div v-for="post in posts" :key="post.name">
      <!-- Post -->
      <article class="post">
        <header>
          <div class="title">
            <h2>
              <router-link
                :to="{ 
              name: 'Entry', 
              params: { 
                year: getDate(post.post_date, 'year'), 
                month: getDate(post.post_date, 'month'), 
                day: getDate(post.post_date, 'day'), 
                title: post.post_name, 
                entry: post 
                } 
              }"
              >{{ post.post_title }}</router-link>
            </h2>
            <p>{{$t('blog.published')}} {{ $d(new Date(post.post_date.replace(/-/g, "/")), 'short') }}</p>
          </div>
        </header>
        <p v-html="post.post_content"></p>
      </article>
    </div>
  </div>
</template>

<script>
import { Trans } from "../localization/Translation.js";
import ContentLoader from "../components/BlogLoader.vue";
import SyntaxHelper from "../helpers/syntaxHelper.js";
import BlogHelper from "../helpers/blogHelper"

export default {
  name: "blog",
  components: {
    ContentLoader
  },
  computed: {
    currentLanguage() {
      return Trans.currentLanguage;
    }
  },
  methods: {
    getBlogPosts() {
      this.posts = [];
      this.hasCalled = false;
      let postsURL =
        "https://fernandomt.com/" +
        this.currentLanguage +
        "/wp-json/blog/v1/posts";
      fetch(postsURL)
        .then(r => r.json())
        .then(res => ((this.posts = res), (this.hasCalled = true)));
    },
    getDate(dateValue, type) {
      let date = new Date(dateValue.substring(0, 10));
      switch (type) {
        case "day":
          var day = date.getDate();
          day = day < 10 ? "0" + day : day;
          return day;
        case "month":
          var month = date.getMonth() + 1;
          month = month < 10 ? "0" + month : month;
          return month;
        case "year":
          return date.getFullYear();
        default:
          return "";
      }
    },
    formatPosts() {
      BlogHelper.cleanImages(this.$el)
      SyntaxHelper.highlightCode(this.$el);
    }
  },
  data() {
    return {
      posts: [],
      hasCalled: false
    };
  },
  mounted() {
    this.getBlogPosts();
  },
  updated() {
    this.formatPosts()
  },
  watch: {
    currentLanguage() {
      this.getBlogPosts();
    }
  }
};
</script>

<style scoped>
 .post >>> img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
